import { createContext, useContext } from "react";

import { SIZES } from "@frontend/styles/constants";

export type ControlSize = (typeof SIZES)[number];

export type ControlContextValue = {
  size: ControlSize;
};

export function makeControlContext({
  size = "md",
}: Partial<ControlContextValue> = {}): ControlContextValue {
  return { size };
}

export const ControlContext =
  createContext<ControlContextValue>(makeControlContext());

export function useControlContext(): ControlContextValue {
  return useContext(ControlContext);
}
